/*
 *******************************************************************************
 *
 *  Filename:   @/contexts/shared/initializer.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Initialize for contexts.
 *
 *  Author:     Norman J. Nolasco [ Archetact Software ]
 *
 *  Created:    Saturday, August 19, 2023 - 10:00 PM (CST)
 *
 *  Notes:
 *
 *  Revisions:
 *              2023/08/19  NJN Initial Build
 *
 *  Copyright (c) 2023 - Archetact Software - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */
import { fetchApi } from "@/utils/fetchApi";
import { isValidToken, setSession } from "@/utils/jwt";
import { INITIALIZE } from "./constants";

export const initializer = async (dispatch) => {
  //console.log("initializer");
  try {
    const accessToken = window.localStorage.getItem("accessToken");
    //console.log("existing accessToken", accessToken);
    //console.log("is access token valid", isValidToken(accessToken));
    const authToken = JSON.parse(window.localStorage.getItem("authToken"));
    if (accessToken && isValidToken(accessToken)) {
      setSession(authToken);
      const response = await fetchApi("users", "authorizeUser", {});
      //console.log("IN HERE", response);
      const authenticationResult = response.authenticationResult;
      const user = response.userResult;
      const isAuthenticated = authenticationResult === "Authorized";
      dispatch({
        type: INITIALIZE,
        payload: {
          isAuthenticated: isAuthenticated,
          authToken: authToken ? authToken : null,
          user,
        },
      });
      return {
        isAuthenticated: isAuthenticated,
        isInitialized: true,
        authToken: authToken ? authToken : null,
        user,
        newPasswordRequired: false,
      };
    } else {
      dispatch({
        type: INITIALIZE,
        payload: {
          isAuthenticated: false,
          user: null,
        },
      });
    }
  } catch (err) {
    console.error(err);
    dispatch({
      type: INITIALIZE,
      payload: {
        isAuthenticated: false,
        user: null,
      },
    });
  }
};
